import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from './en.json';
import ko from './ko.json';
import es from './es.json';

export const getStoredLanguage = async (): Promise<string> => {
	try {
		let language = localStorage.getItem('selectedLanguage')
		if(null == language || '' === language) {
			// 설정 없음
			language = 'default'
		}
		return language
	} catch (error) {
		console.error('Failed to get stored language', error)
		return 'en'
	}
}

export const changeLanguage = async (language: string): Promise<void> => {
	try {
		console.log(`changeLanguage : ${language}`);
		if('' === language || 'default' === language) {
			language = await getOSLanguage()
			localStorage.setItem('selectedLanguage', 'default');
			i18n.changeLanguage(language)
		} else {
			localStorage.setItem('selectedLanguage', language);
			i18n.changeLanguage(language)
		}
	} catch (error) {
		console.error('Failed to change language', error)
	}
}

export const getOSLanguage = async (): Promise<string> => {
	const systemLanguage  = navigator.language;
	const osLanguage = systemLanguage.slice(0, 2)

	console.log(`getOSLanguage : ${osLanguage}`)

	if ('ko' === osLanguage) {
		console.log("OS(브라우저) 언어 한글.");
		// return 'ko'
		return 'en'
	} else {
		// 기본 언어 텍스트 표시
		console.log("OS(브라우저) 한국어 아님. 영어 표시.");
		return 'en'
	}
	// } else if ('es' === osLanguage) {
	// 	// 스페인어 텍스트 표시
	// 	console.log("OS(브라우저) 언어 스페인어.");
	// 	return 'es'
}

export const initI18n = async (): Promise<void> => {	
	let language = await getStoredLanguage()
	if('' === language || 'default' === language) {
		language = await getOSLanguage()
	}

	i18n.use(initReactI18next).init({
		compatibilityJSON: 'v3',
		fallbackLng: 'en',
		lng: language,
		resources: {
			en: { translation: en },
			ko: { translation: ko },
			es: { translation: es }
			// id: { translation: id }
		},
		interpolation: {
			escapeValue: false
		},
		react: {
			useSuspense: true
		}
	})
}

export default i18n;
